export const DRAFT_STATUS_LIST_MUTATION = "DRAFT_STATUS_LIST_MUTATION";
